<template>
  <MainLayout>
    <DetailForm
      title="Edit"
      description="This form will edit a teammate"
      action="Save"
      @handle-cancel="$router.go(-1)"
      @handle-action="handleSubmit"
    >
      <TeammateForm v-if="showEdit" :model-value="contact" @update:model-value="updateContact" />
    </DetailForm>
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/layouts/MainLayout/index.vue';
import DetailForm from '../shared/DetailForm.vue';
import TeammateForm from './TeammateForm.vue';
import { toast } from 'vue-sonner';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';
import RailsUtility from '@/utilities/rails';

export default {
  components: {
    MainLayout,
    DetailForm,
    TeammateForm,
  },
  props: ['record'],
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  data() {
    return {
      contact: {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        licenseStatus: '',
        reLicenseNumber: '',
      },
      showEdit: false,
    };
  },
  mounted() {
    this.getContact();
  },
  methods: {
    updateContact(value) {
      this.contact = value;
    },
    getContact() {
      const self = this;
      this.loadingSpinnerStore.showLoadingSpinner();
      fetch(`/api/teammates/${self.$route.params.id}`)
        .then(response => {
          this.loadingSpinnerStore.hideLoadingSpinner();
          return response.json();
        })
        .then(data => {
          self.contact.name = data.record.name;
          self.contact.firstName = data.record.first_name;
          self.contact.lastName = data.record.last_name;
          self.contact.phone = data.record.phone_number;
          self.contact.email = data.record.email;
          self.contact.licenseStatus = RailsUtility.convertFromCasedEnumFormat(data.record.license_status);
          self.contact.reLicenseNumber = data.record.re_license_number;
          self.showEdit = true;
        });
    },
    handleSubmit() {
      const self = this;
      this.loadingSpinnerStore.showLocalLoadingSpinner();
      fetch(`/api/teammates/${self.$route.params.id}`, {
        method: 'PUT',
        body: JSON.stringify({
          first_name: self.contact.firstName,
          last_name: self.contact.lastName,
          phone_number: self.contact.phone,
          email: self.contact.email,
          stage: self.contact.stage,
          license_status: RailsUtility.convertToCasedEnumFormat(self.contact.licenseStatus),
          re_license_number: self.contact.reLicenseNumber,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(async data => {
          this.loadingSpinnerStore.hideLocalLoadingSpinner();
          if (data.status != 'error') {
            await self.$router.push(`/team/${self.$route.params.id}`);
            toast.success('Teammate edited', {
              action: { label: 'Dismiss' },
              description: 'Your Teammate was successfully edited.  Use the button below to dismiss this alert.',
            });
          } else {
            toast.error('Teammate edit error', {
              action: { label: 'Dismiss' },
              description: data.message,
            });
          }
        });
    },
    handleCancel() {
      this.$emit('handleContactEditCancel');
    },
  },
};
</script>
